document.addEventListener('DOMContentLoaded', function () {
    devtricker_createSubmitCommentOnClickEvent();
});

function devtricker_createSubmitCommentOnClickEvent() {
    let submitCommentButton = document.getElementById('submit-comment-button');
    if (submitCommentButton) {
        submitCommentButton.addEventListener('click', async function () {
            await devtricker_submitComment();
        });
    }
}

function devtricker_calculateCommentListDepth(selector, element){
    let depth = 0;
    
    let commentList;
    
    if(element){
        commentList = element;
    }else{
        commentList = document.querySelector(selector);
    }

    while(commentList){

        if(commentList.classList.contains('comment-list')){
            return 0;
        }

        depth++;

        commentList = commentList.parentNode.closest('.children');
    }

    return depth;
}

async function devtricker_submitComment() {
    let commentForm = document.getElementById('commentform');
    let text = commentForm.querySelector('textarea');
    let commentParentId = document.getElementById('comment_parent').value;
    let parentSelector = commentParentId == "0" ? '.comment-list' : `#li-comment-${commentParentId} .children`;

    let commentList = document.querySelector(`#li-comment-${commentParentId} .children`);
    if (commentList) {
        commentList.style.display = 'block';
    }

    let placeholder = devtricker_insertPlaceholderComment_v2(parentSelector, false);
    devtricker_removeStartConversationIfExist();
    devtricker_collapseCommentForm();

    try {

        let postId = devtricker_getThePostId();
        let commentText = text.value;

        devtricker_resetCommentFormFieldValues();
        devtricker_clearReply();
        devtricker_scrollToElementAndFocus('main-thread-comment-placeholder');

        let commentElement = await devtricker_submitAjaxComment(postId, commentText, commentParentId);

        setTimeout(devtricker_warmUpCache, 2000);

        placeholder.remove();
        devtricker_insertComment_v2(commentElement, parentSelector, false);

        devtricker_process_initializeAllHovercards();
        devtricker_initializeOtherCommentOption();
        devtricker_initializeCodeHighlights();
        // devtricker_initializeLikedFill();
        devtricker_incrementMainThreadCommentCounter(1);
        devtricker_updateCommentsNumberTooltip(1);
        devtricker_updateCommentsNumberButton2(1);
        // devtricker_createIfNotExistsRepliesButton(commentParentId);
        devtricker_incrementRepliesText(commentParentId, 1);
        updateCommentTimes();


    } catch (error) {
        placeholder.remove();
        devtricker_log(error, devtricker_log_level.ERROR, "Error when submit a comment.");
        devtricker_showCommentToast(devtricker_createErrorToast('top', 0, error.message));
    }
}

function devtricker_replyComment(event, button, commentId) {
    event.preventDefault();

    let commentFormTextArea = document.querySelector('#comment-form-wrapper textarea');
    let replyPreview = document.querySelector('.comment-reply-view');

    if (commentFormTextArea) {
        commentFormTextArea.click();
        commentFormTextArea.focus();
        g_devtricker_comment_form_is_expanded = true;
    }

    let depth = devtricker_calculateCommentDepth('#li-comment-' + commentId);
    console.log('Comment depth:', depth);

    let currentReplyingTo = document.querySelector('#li-comment-' + commentId);
    let effectiveReplyingAuthorName;
    let effectiveReplyingToId;
    let currentAuthorHandler;

    if (!currentReplyingTo) {
        console.warn(`Comment with ID ${commentId} not found in DOM.`);
        return;
    }

    if (depth >= 2) {
        let ol = currentReplyingTo.closest('.children');
        let parentComment = ol?.closest('.comment');

        if (parentComment) {
            const parentAuthorEl = parentComment.querySelector('.comment-author-link') || parentComment.querySelector('.comment-author-name');

            effectiveReplyingAuthorName = parentAuthorEl?.innerText || 'Guest';
            effectiveReplyingToId = parentComment.id.split('-').pop();
            currentAuthorHandler = currentReplyingTo.querySelector('.comment-author-link')?.getAttribute('data-author-handle') || null;
        } else {
            effectiveReplyingAuthorName = 'Guest';
            effectiveReplyingToId = commentId;
            currentAuthorHandler = null;
        }

    } else {
        const authorEl = currentReplyingTo.querySelector('.comment-author-link') || currentReplyingTo.querySelector('.comment-author-name');

        effectiveReplyingAuthorName = authorEl?.innerText || 'Guest';
        effectiveReplyingToId = commentId;
        currentAuthorHandler = currentReplyingTo.querySelector('.comment-author-link')?.getAttribute('data-author-handle') || null;
    }

    const previewDiv = document.querySelector('#comment-reply-wrapper');
    const authorElement = document.querySelector('.comment-reply-view-author');

    if (authorElement) {
        authorElement.innerText = ` ${effectiveReplyingAuthorName}`;
    }

    const commentParentInput = document.querySelector('#comment_parent');
    if (commentParentInput) {
        commentParentInput.value = effectiveReplyingToId;
    }

    const commentFormTextarea = document.querySelector('#comment');
    if (commentFormTextarea) {
        commentFormTextarea.focus();
        if (currentAuthorHandler) {
            commentFormTextarea.value = `${currentAuthorHandler} `;
        }
    }

    const cancelReplyLink = document.querySelector('#cancel-comment-reply-link');
    if (cancelReplyLink) {
        cancelReplyLink.removeAttribute('href');
        cancelReplyLink.addEventListener('click', function () {
            if (commentParentInput) commentParentInput.value = '0';
            if (previewDiv) previewDiv.innerHTML = '';
        });
    }

    let commentForm = document.getElementById('comment-form-wrapper');
    if (commentForm) {
        commentForm.style.height = 'auto';
    }

    if (replyPreview) {
        replyPreview.style.display = 'flex';
    }
}

function devtricker_clearReply() {
    let preview = document.getElementById('comment-reply-wrapper');
    let parent = document.getElementById('comment_parent');
    let element = document.querySelector('.comment-reply-view');
    let newPreview = document.querySelector('#preview');

    if (preview) {
        preview.innerHTML = '';
        parent.value = "0";
    }

    if (newPreview) {
        newPreview.innerHTML = '';
        parent.value = "0";
    }

    element.style.display = 'none';
}

function devtricker_scrollToElementAndFocus(elementId) {
    var element = document.getElementById(elementId);

    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (!element.hasAttribute('tabindex')) {
            element.setAttribute('tabindex', '-1');
        }

        element.focus();
    } else {
        console.error("Element with ID '" + elementId + "' not found.");
    }
}

function devtricker_resetCommentFormFieldValues() {
    document.querySelector('#commentform textarea').value = '';
    document.getElementById('comment_parent').value = 0;

    document.getElementById('submit-comment-button').disabled = true;
}

function devtricker_insertComment_v2(comments, parentSelector, atTheEnd = true) {

    //AAAA

    if (comments.length == 0) {
        return;
    }

    let commentListElement = devtricker_createIfNotExistsChildrenCommentList(parentSelector);

    let depth = devtricker_calculateCommentListDepth(null, commentListElement);

    if(depth >= 2){
        atTheEnd = true;
    }

    if (atTheEnd) {
        comments.forEach(comment => {

            let exist = document.getElementById(comment.id);

            if (!exist) {
                commentListElement.append(comment);
            }
        });
    } else {
        comments.forEach(comment => {
            let exist = document.getElementById(comment.id);

            if (!exist) {
                commentListElement.prepend(comment);
            }
        });
    }
}

function devtricker_createIfNotExistsRepliesButton(parentCommentId, numReplies = 0) {
    let commentParent = document.getElementById(`li-comment-${parentCommentId}`);

    if (commentParent) {
        let replyButton = commentParent.querySelector(".reply-counter");

        if (!replyButton) {
            let buttonHtml = `
                <div class=' d-flex align-items-center'>
                    ${numReplies > 0 ? `
                        <button type='button' onclick='devtricker_loadCommentChildren(event, this, ${parentCommentId})'
                            class='btn reply-counter text-body-secondary d-flex align-items-center'>
                            <span class='reply-counter-text fw-semibold'>
                                ${numReplies} ${numReplies === 1 ? 'reply' : 'replies'}
                            </span>
                            <span class=" icon icon-chevron-down"></span>
                        </button>
                    ` : ''}
                </div>
            `;

            let tmp = document.createElement('div');
            tmp.innerHTML = buttonHtml.trim();

            let newButtonContainer = tmp.firstChild;
            let replyWrapper = commentParent.querySelector(".reply-wrapper");
            
            if (replyWrapper) {
                replyWrapper.append(newButtonContainer);
            }
        }
    }
}

function devtricker_incrementRepliesText(parentCommentId, value) {

    let button = document.querySelector(`#li-comment-${parentCommentId} .reply-counter`);

    if (button && parentCommentId != 0) {
        devtricker_changeRepliesButtonToHideButton(null, button, parentCommentId);

        let originalText = g_devtricker_replies_original_text[parentCommentId];

        if (originalText) {

            let commentCounter = originalText.split(' ')[0];

            if (commentCounter) {
                let currentCount = parseInt(commentCounter) || 0;
                let items = document.querySelectorAll(`#li-comment-${parentCommentId} .children > .comment`);

                let originalCount = currentCount;

                currentCount += value;
                let text = currentCount == 1 ? 'reply' : 'replies';

                if (currentCount > items.length) {
                    devtricker_addLoadMoreChildComments(parentCommentId, `#li-comment-${parentCommentId} .children`, originalCount);
                }

                g_devtricker_replies_original_text[parentCommentId] = `${currentCount} ${text}`;


                if (currentCount == 0) {
                    button.remove();
                    delete g_devtricker_replies_original_text[parentCommentId];
                }

            }
        }
    }
}

function devtricker_addLoadMoreChildComments(commentId, parentSelector, commentNumber) {

    let parent = devtricker_createIfNotExistsChildrenCommentList(parentSelector);
    let loadMoreButton = parent.querySelector('.show-more');

    if (!loadMoreButton) {
        let buttonWrapper = document.createElement('div');
        buttonWrapper.classList.add('mt-2');

        let moreText = commentNumber >= 3 ? '3+' : `${commentNumber}+`;

        let button = document.createElement('button');
        button.innerText = `Show ${moreText} more`;
        button.classList.add('btn', 'show-more', 'fw-semibold', 'd-flex');
        button.style.textDecoration = 'underline';
        button.style.border = '0';
        button.style.padding = '0';
        button.style.fontSize = '0.875rem';

        buttonWrapper.append(button);

        parent.append(buttonWrapper);

        button.onclick = function (event) {
            buttonWrapper.remove();

            devtricker_loadCommentChildren(event, buttonWrapper, commentId);
        };
    }
}

function devtricker_updateCommentsNumberTooltip(value) {
    const button = document.getElementById('open-comments-button');
    if (!button) return;

    let currentTitle = button.getAttribute('data-bs-original-title');
    let parts = currentTitle.split(' ');
    let currentNumber = parts[0] === 'Be' ? 0 : parseInt(parts[0]);
    if (isNaN(currentNumber)) {
        currentNumber = 0;
    }

    let newNumber = currentNumber + value;
    if (newNumber < 0) newNumber = 0;

    let newTitle = newNumber === 0 ? 'Be the first to comment' :
        newNumber === 1 ? '1 comment' :
            `${newNumber} comments`;

    button.setAttribute('data-bs-original-title', newTitle);
    button.setAttribute('aria-label', newTitle);

    if (bootstrap && bootstrap.Tooltip.getInstance(button)) {
        let tooltipInstance = bootstrap.Tooltip.getInstance(button);
        tooltipInstance.update();
    } else {
        new bootstrap.Tooltip(button, {
            placement: 'top',
            title: newTitle
        });
    }
}

function devtricker_updateCommentsNumberButton2(value) {
    const button = document.getElementById('open-comments-button-2');
    if (!button) return;

    let commentTextElement = button.querySelector('span');
    if (!commentTextElement) return;

    let currentText = commentTextElement.textContent.trim();
    let currentNumber = currentText === 'Be the first to comment' ? 0 : parseInt(currentText.split(' ')[0]);

    if (isNaN(currentNumber)) {
        currentNumber = 0;
    }

    let newNumber = currentNumber + value;
    if (newNumber < 0) newNumber = 0;

    let newCommentText = newNumber === 0 ? 'Be the first to comment' :
        newNumber === 1 ? '1 comment' :
            `${newNumber} comments`;

    commentTextElement.textContent = newCommentText;
}

function devtricker_removeStartConversationIfExist() {
    let startConversation = document.getElementById('start-comment');

    if (startConversation) {
        startConversation.remove();
    }
}


function devtricker_calculateCommentDepth(commentSelector) {
    let depth = 0;
    let commentElement = document.querySelector(commentSelector);

    if (!commentElement) {
        console.error("Comment element not found");
        return depth;
    }

    let currentList = commentElement.closest('.children');

    while (currentList) {
        depth++;

        currentList = currentList.parentNode.closest('.children');
    }

    return depth;
}